import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';
import { CircularProgressProps, Stack, SxProps } from '@mui/material';

interface CustomCircularProps extends CircularProgressProps {
  customSx?: SxProps;
  customColor?: string;
  customColor2?: string;
}

const CustomizedCircularProgress = (props: CustomCircularProps) => {
  const { size, thickness, customSx, customColor, customColor2 } = props;
  return (
    <Stack
      sx={{
        ...(customSx && { ...customSx }),
        position: 'relative',
      }}
    >
      <CircularProgress
        variant='determinate'
        size={size}
        thickness={thickness}
        value={100}
        sx={{
          color: customColor ?? 'primary',
        }}
        {...props}
      />
      <CircularProgress
        variant='indeterminate'
        disableShrink
        sx={{
          color: customColor2 ?? 'primary.light',
          opacity: 0.7,
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        size={size}
        thickness={thickness}
        {...props}
      />
    </Stack>
  );
};
export default CustomizedCircularProgress;
